export default __webpack_public_path__ + "static/media/asap.544c927b.png";